/**
 * ReviewType parameter for ratings and review
 * Note:
 * This is not the complete set of available types, but only the ones used in Academy
 * For the full set see https://tools.hubteam.com/api-catalog/services/ecosystem-service/v1/spec/internal#operations-Reviews-post-%2Fecosystem%2Fv1%2Freviews%2Fstats
 */
export const AcademyRatingsTypes = {
  ACADEMY_COURSE: 'ACADEMY_COURSE',
  ACADEMY_LESSON: 'ACADEMY_LESSON',
  ACADEMY_ON_THE_GO: 'ACADEMY_ON_THE_GO'
};
export const RatingsReviewGroup = {
  LIKE_FEEDBACK: 'LIKE_FEEDBACK',
  DISLIKE_FEEDBACK: 'DISLIKE_FEEDBACK'
};
export const RatingsTagMap = {
  PRACTICAL: 'learningCenter.ratingsAndReview.popover.tags.like.practical',
  ENGAGING: 'learningCenter.ratingsAndReview.popover.tags.like.engaging',
  USEFUL: 'learningCenter.ratingsAndReview.popover.tags.like.useful',
  CLEAR: 'learningCenter.ratingsAndReview.popover.tags.like.clear',
  APPROPRIATE_LENGTH: 'learningCenter.ratingsAndReview.popover.tags.like.appropriateLength',
  ACCESSIBLE: 'learningCenter.ratingsAndReview.popover.tags.like.accessible',
  NOT_PRACTICAL: 'learningCenter.ratingsAndReview.popover.tags.dislike.notPractical',
  NOT_ENGAGING: 'learningCenter.ratingsAndReview.popover.tags.dislike.notEngaging',
  NOT_USEFUL: 'learningCenter.ratingsAndReview.popover.tags.dislike.notUseful',
  CONFUSING: 'learningCenter.ratingsAndReview.popover.tags.dislike.confusing',
  TOO_LONG_SHORT: 'learningCenter.ratingsAndReview.popover.tags.dislike.tooLongShort',
  NOT_ACCESSIBLE: 'learningCenter.ratingsAndReview.popover.tags.dislike.notAccessible'
};